import React, { useState } from "react";
import styled from "styled-components";
import DefaultModalLayout from "../../../Modal/DefaultModalLayout";
import type { IYoutube } from "../../../../pages/Party/YoutubeMatchingInfo";
import { copyMatchingUsersForExcel } from "../../../../pages/Party/matchingUserClipboard";

interface MatchingSelectionModalProps {
  selectedItems: IYoutube[];
  closeEvent: () => void;
}

export default function MatchingSelectionModal({
  selectedItems,
  closeEvent,
}: MatchingSelectionModalProps) {
  const [copying, setCopying] = useState(false);

  return (
    <DefaultModalLayout
      modalTitle="선택 기능"
      modalDesc={`${selectedItems.length}건 선택됨`}
      closeEvent={closeEvent}
      confirmEvent={closeEvent}
      confirmBtnText="닫기"
      cancelBtn={<></>}
      leftBottomBtn={<></>}
      isSmallModal
    >
      <ActionList>
        <CopyActionButton
          type="button"
          disabled={copying}
          onClick={async () => {
            setCopying(true);
            const copied = await copyMatchingUsersForExcel(selectedItems);
            if (copied) {
              closeEvent();
            } else {
              setCopying(false);
            }
          }}
        >
          <span className="material-icons-outlined" aria-hidden="true">
            content_copy
          </span>
          선택 복사
        </CopyActionButton>
      </ActionList>
    </DefaultModalLayout>
  );
}

const ActionList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const CopyActionButton = styled.button`
  width: 100%;
  min-height: 48px;
  padding: 10px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  background: ${({ theme }) => theme.buttonColor.blueNormal};
  color: ${({ theme }) => theme.color.white};
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;

  &:hover {
    background: ${({ theme }) => theme.buttonColor.blueHover};
  }

  &:active {
    background: ${({ theme }) => theme.buttonColor.bluePressed};
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.buttonColor.blueNormal};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.6;
    cursor: wait;
  }

  .material-icons-outlined {
    font-size: 18px;
  }
`;
